import {
  EmptyStateAction,
  EmptyStateWithIllustration,
} from 'components/EmptyState'

interface ICategoryErrorProps {
  onClick: () => void
}
const CategoryError: React.FC<ICategoryErrorProps> = ({ onClick }) => {
  return (
    <div className="px-12 py-8">
      <EmptyStateWithIllustration
        title="Terjadi kendala sistem"
        description="Silakan coba lagi dalam beberapa saat."
        fullscreen={false}
        className="w-full text-center"
      >
        <EmptyStateAction
          data-testid="error-boundary-action-primary"
          size="lg"
          className="w-full mt-2 mb-2"
          onClick={onClick}
        >
          Coba lagi
        </EmptyStateAction>
      </EmptyStateWithIllustration>
    </div>
  )
}

export default CategoryError
